import { RegionSetStatusType } from "@app/projects/enumerators";

export const SERVICE_AREA_STATUS_DISPLAY_ORDER: readonly RegionSetStatusType[] = [
  RegionSetStatusType.Active,
  RegionSetStatusType.Pending,
  RegionSetStatusType.Approved,
  RegionSetStatusType.Opportunity,
];
